
export class JsUtil {

    public static setMultiSelectLabel(multiselectId: string, translation: string) {
        this.waitForMultiSelectLabel(multiselectId).then(() => {
            (document.getElementById(multiselectId)
                .getElementsByClassName('ui-multiselect-label-container')[0]
                .getElementsByClassName('ui-multiselect-label')[0]).textContent = translation;
        });
    }

    private static async waitForMultiSelectLabel(componentMultiselectId: string) {
        const timeBetweenTriesInMilliseconds = 500;
        const maxNbTries = 30;
        let nbTries = 0;
        while(!document.getElementById(componentMultiselectId) && (nbTries++ < maxNbTries)) {
            await new Promise(r => setTimeout(r, timeBetweenTriesInMilliseconds));
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/util/jsUtil.ts